import { useQueryClient } from "@tanstack/react-query";
import { leadApi } from "api/lead";
import { InputSize } from "shared/components";
import { AssigneeSelect as SharedAssigneeSelect } from "shared/components/Assignee";

interface AssigneeSelectProps {
  value?: number | null;
  rowId?: string;
  propertyId?: number;
  inputClassName?: string;
  labelClassName?: string;
  onChange?: (assignee_id: number | null) => void;
  label?: string;
  size?: InputSize;
}

export const AssigneeSelect = ({
  value,
  rowId,
  propertyId,
  inputClassName,
  labelClassName,
  onChange,
  label,
  size
}: AssigneeSelectProps) => {
  const queryClient = useQueryClient();

  const handleAssign = async (row_id: string, assignee_id: number | null) => {
    return leadApi.assignLead({
      lead_id: Number(row_id),
      assignee_ids: assignee_id !== null ? [assignee_id] : []
    });
  };

  const handleAssignSuccess = () => {
    queryClient.refetchQueries({ queryKey: ["LEAD_ACTIVITY_LOG"] });
    queryClient.refetchQueries({ queryKey: ["LEADS_TABLE"] });
    if (rowId) queryClient.refetchQueries({ queryKey: ["LEAD", rowId] });
  };

  return (
    <SharedAssigneeSelect
      value={value}
      rowId={rowId}
      propertyId={propertyId}
      labelClassName={labelClassName}
      inputClassName={inputClassName}
      onChange={onChange}
      onAssign={handleAssign}
      onAssignSuccess={handleAssignSuccess}
      label={label}
      size={size}
      successMessage="Lead assigned successfully"
      errorMessage="Failed to assign lead"
    />
  );
};
